// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';
import { TABLET_SMALL_WIDTH } from 'commons/constants/size';

const {
  fonts: { header },
  palette: { greyscale },
} = getTheme();
const PartnerProgramsWrapper: StatelessFunctionalComponent<any> = styled.div`
  background-color: ${greyscale.white};
  min-height: 70rem;
  padding: 2.4rem 1.6rem 7.2rem 1.6rem;
  display: flex;
  justify-content: center;

  .partner-programs {
    &__container {
      max-width: 160rem;
    }

    &__description {
      color: ${greyscale.mineShaft};
      display: block;
      font-size: 1.6rem;
      line-height: 2.4rem;
      margin-bottom: 3rem;
      text-align: center;
    }

    &__header {
      color: ${greyscale.mineShaft};
      font-family: ${header};
      font-size: 4rem;
      line-height: 4.4rem;
      margin: 0;
      margin-bottom: 1.6rem;
      text-align: center;
    }
  }

  .sorter-section {
    align-items: baseline;
    display: flex;
    margin-bottom: 2.7rem;

    &__sort-by {
      color: ${greyscale.doveGray};
      font-size: 1.6rem;
      line-height: 1.9rem;
      margin-right: 0.8rem;
    }
  }

  @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
    display: block;
  }
`;
export default PartnerProgramsWrapper;
